export default "__VITE_ASSET__c89ed9db__"